import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router} from'@angular/router';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { MapPin } from '../classes/MapPin';
import { BehaviorSubject, Observable } from 'rxjs';
import { PopupService } from './popup.service';
import { LoaderService } from './loader.service';

@Injectable()
export class PinService {

  constructor(public httpClient: HttpClient, public router: Router, public baseService: BaseService,
              public popupService: PopupService, public loaderService : LoaderService) { }

  previousBounds: any;
  openPinSection: boolean = false;

  pageNumber: number = 1;
  deletedPinsPageNumber: number = 1;

  allFetched: boolean = false;
  allDeletedFetched: boolean = false;

  recordsPerPage: number = 10;

  fetching: boolean = false;
  deletedPinsfetching: boolean = false;

  searchValue: string = '';
  deletedSearchValue: string = '';

  pins: MapPin[] = [];
  deletedPins: any[] = [];

  pinsInputElement: any;
  pinsContainerElement: any;

  fetchPinsSource = new BehaviorSubject<boolean>(false);
  fetchPinsStream = this.fetchPinsSource.asObservable();

  getMapPins() {
    let url = environment.APP.API_URL + '/my/pin?pageNumber=' + this.pageNumber
     + '&recordsPerPage=' + this.recordsPerPage
     + '&name=' +  encodeURIComponent(this.searchValue);
    return this.httpClient.get(url)
      .map((res: any) => {
        (res.length === this.recordsPerPage) ? this.pageNumber++ : this.allFetched = true;
        return res;
      });
  }

  getMapDeletedPins() {
    let url = environment.APP.API_URL + '/my/pin?pageNumber=' + this.deletedPinsPageNumber
     + '&recordsPerPage=' + this.recordsPerPage
     + '&name=' +  encodeURIComponent(this.deletedSearchValue)
     + '&deleted=true';
    return this.httpClient.get(url)
      .map((res: any) => {
        (res.length === this.recordsPerPage) ? this.deletedPinsPageNumber++ : this.allDeletedFetched = true;
        return res;
      });
  }

  resetPins() {
    this.pins = [];
    this.deletedPins = [];
    this.pageNumber = 1;
    this.deletedPinsPageNumber = 1;
  }

  addPin(mapPin) {
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.post(
      environment.APP.API_URL + '/map-pin',
      JSON.stringify(mapPin),
      { headers }
    )
    .map((res) => {
      return res;
    });
  }

  editPin(mapPin, pinId) {
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.put(
      environment.APP.API_URL + '/map-pin/' + pinId,
      JSON.stringify(mapPin),
      { headers }
    )
    .map((res) => {
      return res;
    });
  }

  deletePin(pinId) {
    return this.httpClient.delete( environment.APP.API_URL + '/map-pin/'+pinId)
    .map( (res) => {
      return res;
    });
  }

  resetPagination() {
    this.pageNumber = 1;
    this.allFetched = false;
    this.pins = [];
  }

  resetDeletedPagination() {
    this.deletedPinsPageNumber = 1;
    this.allDeletedFetched = false;
    this.deletedPins = [];
  }

  searchPins() {
    this.resetPagination();
    this.fetchPins();
  }

  fetchPins() {
    if(!this.fetching && !this.allFetched) {
      this.fetching = true;
      this.loaderService.addGreyLoaderClass();
      this.getMapPins().subscribe((data: any) => {
        this.fetching = false;
        for(var i = 0; i < data.length; i++) {
          this.pins.push(data[i]);
          !this.pinsInputElement && this.addInputEventObservable();
        }
        this.loaderService.removeGreyLoaderClass();
        (<any>window).Events.publish('detectChanges');
      }, (error)=>{
        this.fetching = false;
        throw(error);
      });
    }
  }

  addInputEventObservable() {
    this.pinsInputElement = document.getElementById('pins-search-input');
    if(this.pinsInputElement) {
      Observable.fromEvent(this.pinsInputElement, 'input')
        .debounceTime(500)
        .subscribe((event) => {
          this.searchPins();
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pin.service.ts